<template>
    <div name="hrms-lov">
      <div class="lov-box clearfix" :class="{ '' : flgInlineTable }">
        <div>
          <input type="text" class="form-control lov-input text-uppercase"
                 v-model="inputValue"
                 :disabled="disabled"
                 :ref="lovType"
                 :name="name"
                 @focusout="findDescInputValue(inputValue)"
                 @keyup="inputValue = inputValue.toUpperCase()"
                 @keyup.tab="findDescInputValue(inputValue)"
                 @keyup.enter="findDescInputValue(inputValue)"
                 @change="findDescInputValue(inputValue)"
                 :maxlength="maxlength" />
          <button v-if="disabled" class="btn-lov-disable" @click.prevent=""><i class="fa fa-search"></i></button>
          <button v-if="!disabled" class="btn-lov" @click.prevent="showModal = true"><i class="fa fa-search color-skin"></i></button>

        </div>
        <div v-show="lovType !== 'nummemo'">
          <input type="text" class="form-control detail-lov" :disabled="true" v-show="descDisp" v-model="descInputValue"  />
        </div>
      </div>

      <transition name="modal">
        <div v-if="showModal" class="modal-mask" >
          <div class="modal-wrapper"  >
            <div class="modal-container">

              <div class="modal-header">
                <slot name="header">
                  <i class="fa fa-close close" @click.prevent="closeModal()" ></i>
                  <h4 class="modal-title">{{ title[lovType] }}</h4>
                </slot>
              </div>

              <div class="modal-body">
                <slot name="body">
                  <hrms-table :columns="columns[nowLang][lovType]"
                              :data="dataLov[lovType]"
                              :indexDisp="false"
                              :isLovTable="true"
                              @setLoadingParentBool="loadingParentBool = arguments[0]"
                              :loadingParentBool="loadingParentBool"
                              :tickEvent="tickEvent" />
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as types from 'store/modules/hrmsLov/mutation-types'
import labels from 'src/../config/label'

export default {
  name: 'hrms-lov',
  data () {
    return {
      showModal: false,
      inputValue: this.value,
      descInputValue: this.desc,
      descLovType: 'desc_' + this.lovType
    }
  },
  watch: {
    lovType () {
      this.descLovType = 'desc_' + this.lovType
      this.receivedLov({ lovType: this.lovType, params: this.params })
    },
    baseListsLovType () {
      let _this = this
      this.inputValue = this.value
      setTimeout(function () {
        _this.findDescInputValue(_this.value)
      }, 100)
    },
    value () {
      if (this.value !== this.inputValue) {
        let _this = this
        this.inputValue = this.value
        setTimeout(function () {
          _this.findDescInputValue(_this.value)
        }, 100)
      }
    },
    params () {
      this.receivedLovColumnsLabels(this.lovType)
      this.receivedLov({ lovType: this.lovType, params: this.params })
    },
    lovFinish () {
      if (this.lovFinish) {
        this.findDescInputValue(this.value)
      }
    }
  },
  created () {
    this.receivedLovColumnsLabels(this.lovType)
    this.receivedLov({ lovType: this.lovType, params: this.params })
    this.findDescInputValue(this.value)
  },
  props: {
    value: {
      type: String,
      required: true
    },
    lovType: {
      type: String,
      required: true
    },
    params: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    nowLang: {
      type: String,
      default: labels.defaultLang
    },
    name: {
      type: String,
      required: true
    },
    flgInlineTable: {
      type: Boolean,
      default: false
    },
    descDisp: {
      type: Boolean,
      default: true
    },
    desc: {
      type: String,
      default: ''
    },
    maxlength: {
      type: Number
    }
  },
  computed: {
    loadingParentBool () {
      return this.dataLov[this.lovType].loading
    },
    baseListsLovType () {
      return this.dataLov[this.lovType]
    },
    lovFinish () {
      return this.dataLov[this.lovType].finish
    },
    ...mapGetters({
      dataLov: types.GET_LOV,
      title: types.GET_LOV_TITLE,
      columns: types.GET_LOV_COLUMNS,
      labels: types.GET_LOV_LABELS
    })
  },
  methods: {
    findDescInputValue (inputValue) {
      if (this.lovFinish) {
        if (inputValue !== '' && this.dataLov[this.lovType].rows.length > 0) {
          let _this = this
          let params = this.dataLov[this.lovType].rows.filter(function (dataRow) {
            return dataRow[_this.lovType] === inputValue
          })
          if (params.length > 0) {
            if (this.lovType === 'nummemo') {
              this.descLovType = 'nummemo'
            }
            this.$emit('fineDescLov', 'found')
            this.$emit('setDataRow', params[0])
            this.descInputValue = params[0][this.descLovType]
          } else {
            this.$emit('fineDescLov', 'notFound')
            this.inputValue = ''
            this.descInputValue = ''
          }
        } else {
          this.inputValue = ''
          this.descInputValue = ''
          this.$emit('fineDescLov', 'notFound')
        }
      }
      this.$emit('input', inputValue)
    },
    closeModal () {
      this.showModal = false
      this.$refs[this.lovType].focus()
    },
    tickEvent (param) {
      this.inputValue = param[this.lovType]
      this.descInputValue = param[this.descLovType]
      this.$emit('setDataRow', param)
      this.$emit('input', param[this.lovType])
      this.$emit('changeLov', param[this.lovType])
      this.closeModal()
    },
    // focusOutEvent (inputValue) {
    //   this.findDescInputValue(inputValue)
    //   console.log(this.dataLov[this.lovType])
    //   let param = this.dataLov[this.lovType].rows.filter(dataFilter => {
    //     return dataFilter.
    //   })
    //   this.$emit('setDataRow', param)
    // },
    ...mapActions({
      receivedLovColumnsLabels: types.RECEIVED_LOV_COLUMNS_LABELS,
      receivedLov: types.RECEIVED_LOV
    })
  }
}
</script>

<style lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow: auto;
  display: block;
}

.modal-wrapper {
  display: block;
}

.modal-container {
  width: 80%;
  max-width: 800px;
  margin: 30px auto;
  padding: 0;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  overflow-x: auto;
  // font-family: Helvetica, Arial, sans-serif;
  @media (max-width: 480px) {
    margin: 0;
    width: 100%;
  }
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 10px 0;
  padding: 10px;
}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>



// WEBPACK FOOTER //
// component.vue?0577c40c